import { gql } from "@apollo/client";
import { MESSAGE_TEMPLATE_FRAGMENT } from "./fragments";

export const GET_MESSAGE_TEMPLATE_AND_RICH_CONTENT = gql`
  ${MESSAGE_TEMPLATE_FRAGMENT}
  query GetMessageTemplateAndRichContent(
    $formTemplateId: uuid!
    $templateType: message_template_type_enum!
    $schoolId: uuid!
    $skipSchool: Boolean!
  ) {
    message_template_standard: message_template(
      where: {
        _and: [
          { form_template_id: { _eq: $formTemplateId } }
          { type: { _eq: $templateType } }
          { school_id: { _is_null: true } }
        ]
      }
    ) {
      ...MessageTemplateFragment
    }
    message_template_school_specific: message_template(
      where: {
        _and: [
          { form_template_id: { _eq: $formTemplateId } }
          { type: { _eq: $templateType } }
          { school_id: { _eq: $schoolId } }
        ]
      }
    ) @skip(if: $skipSchool) {
      ...MessageTemplateFragment
    }
    form_template_by_pk(id: $formTemplateId) {
      name
      enrollment_period {
        id
        name
      }
      sections(where: { type: { _eq: SchoolRankingSection } }) {
        schools_ranking_section {
          ranking_enabled
        }
      }
      school_specific_messages_enabled
      lottery_offers_enabled
    }
    school_by_pk(id: $schoolId) @skip(if: $skipSchool) {
      name
    }
  }
`;
